const FIREBASECONFIG = {
  apiKey: "AIzaSyB11yEc9nPCDzXH8tvBrMKdZbocRt1TLXI",
  authDomain: "kibart-gallery.firebaseapp.com",
  databaseURL: "https://kibart-gallery.firebaseio.com",
  projectId: "kibart-gallery",
  storageBucket: "kibart-gallery.appspot.com",
  messagingSenderId: "84237026232",
  appId: "1:84237026232:web:65d3f30e7466957379c54d"
};

module.exports = {
  FIREBASECONFIG
};
